<template>
  <section class="section">
    <div class="container">
      <div class="columns">
        <div class="column">
          <slot></slot>
          <ValidationObserver v-slot="{ handleSubmit }">
            <form @submit.prevent="handleSubmit(validateBeforeSubmit)">
              <div class="section">
                <s3-avatar-picker
                  v-model="value.userAvatar"
                  @input="handleAvatar"
                />
              </div>
              <section class="section">
                <b-field grouped group-multiline>
                  <b-field expanded :label="$t('Nombre')">
                    <ValidationProvider
                      name="Name"
                      rules="required|alpha"
                      v-slot="{ errors }"
                    >
                      <b-input
                        expanded
                        :value="value.userFirstName"
                        @input="update('userFirstName', $event)"
                      ></b-input>
                      <p v-show="errors.length" class="help is-danger">
                        {{ errors[0] }}
                      </p>
                    </ValidationProvider>
                  </b-field>

                  <b-field expanded :label="$t('Apellidos')">
                    <ValidationProvider
                      name="Surname"
                      rules="required|alpha"
                      v-slot="{ errors }"
                    >
                      <b-input
                        expanded
                        :value="value.userLastName"
                        @input="update('userLastName', $event)"
                      ></b-input>
                      <p v-show="errors.length" class="help is-danger">
                        {{ errors[0] }}
                      </p>
                    </ValidationProvider>
                  </b-field>
                </b-field>
                <b-field grouped group-multiline>
                  <b-field expanded :label="$t('Profesión')">
                    <ValidationProvider
                      name="Profession"
                      rules="required|alpha"
                      v-slot="{ errors }"
                    >
                      <b-input
                        expanded
                        :value="value.jobPosition"
                        @input="update('jobPosition', $event)"
                      ></b-input>

                      <p v-show="errors.length" class="help is-danger">
                        {{ errors[0] }}
                      </p>
                    </ValidationProvider>
                  </b-field>

                  <b-field expanded :label="$t('Ciudad')">
                    <b-input expanded v-model="value.city"></b-input>
                  </b-field>
                  <b-field expanded :label="$t('Idioma')">
                    <b-select
                      expanded
                      :value="value.lang"
                      @input="update('lang', $event)"
                      :placeholder="$t('Selecciona')"
                    >
                      <option value="es">
                        ES
                      </option>
                      <option value="en">
                        EN
                      </option>
                      <option value="ar">
                        عربى
                      </option>
                      <option value="pt">
                        PT
                      </option>
                      <option value="fr">
                        FR
                      </option>
                      <option value="cn">
                        CN
                      </option>
                    </b-select>
                  </b-field>
                </b-field>
                <!---
                <b-field grouped group-multiline>
                  <b-field expanded :label="$t('Teléfono')">
                    <VuePhoneNumberInput v-model="formData.telephone" />
                  </b-field>

                  <b-field expanded :label="$t('País')">
                    <ValidationProvider
                      name="Country"
                      rules="required|alpha"
                      v-slot="{ errors }"
                    >
                      <b-input expanded v-model="formData.country"></b-input>

                      <p v-show="errors.length" class="help is-danger">
                        {{ errors[0] }}
                      </p>
                    </ValidationProvider>
                  </b-field>
                </b-field>
                <b-field grouped group-multiline>
                  <b-field expanded :label="$t('Red Social')">
                    <b-input
                      expanded
                      v-model="formData.socialNetwork"
                    ></b-input>
                  </b-field>

                  <b-field expanded label="Email">
                    <ValidationProvider
                      name="Email"
                      rules="required|email"
                      v-slot="{ errors }"
                    >
                      <b-input
                        expanded
                        v-model="formData.contactEmail"
                      ></b-input>

                      <p v-show="errors.length" class="help is-danger">
                        {{ errors[0] }}
                      </p>
                    </ValidationProvider>
                  </b-field>
                </b-field>
                -->
              </section>
              <div class="has-text-centered">
                <b-button
                  size="is-large"
                  native-type="submit"
                  type="is-primary"
                  >{{ $t('Enviar') }}</b-button
                >
              </div>
            </form>
          </ValidationObserver>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import { ValidationProvider, extend, ValidationObserver } from 'vee-validate'
import { required, alpha, numeric, email } from 'vee-validate/dist/rules'
import S3AvatarPicker from '@/components/common/S3AvatarPicker.vue'
import VuePhoneNumberInput from 'vue-phone-number-input'
import 'vue-phone-number-input/dist/vue-phone-number-input.css'
extend('required', {
  ...required
})

extend('alpha', {
  ...alpha
})

extend('numeric', {
  ...numeric
})

extend('email', {
  ...email
})

export default {
  props: ['value'],
  components: {
    ValidationProvider,
    ValidationObserver,
    VuePhoneNumberInput,
    S3AvatarPicker
  },
  computed: {},
  data() {
    return {}
  },
  methods: {
    handleAvatar(e) {
      this.value.userAvatar = e
    },
    update(key, value) {
      this.$emit('input', { ...this.value, [key]: value })
    },
    validateBeforeSubmit() {
      this.$emit('formSubmit')
    }
  },
  mounted() {}
}
</script>

<style scoped></style>
